import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid2,
  Paper,
  Typography,
} from "@mui/material";
import * as React from "react";
import logosTefl from "../images/logoToefl.png";
import banne3 from "../images/banner_contacto.png";

import info from "../images/info.png";
import test from "../images/test.png";
import agendar from "../images/agendar.png";
import cursos from "../images/cursos.png";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GaleriaLaPaz from "../components/GaleriaLaPaz";
import GaleriaSantaCruz from "../components/GaleriaSantaCruz";
import GaleriaCochabamba from "../components/GaleriaCochabamba";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Helmet } from "react-helmet-async";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Contactos() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Helmet>
        <title> DLS - Contacto</title>

        <meta
          name="description"
          content="Estamos en los 3 departamentos La Paz, Cochabamba y Santa Cruz."
        />
        <meta
          name="keywords"
          content="direccion, bolivia, La Paz, Cochabamba, Santa Cruz, traductor, traduccion, cursos, examenes"
        />
        <meta name="author" content="DLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="icon" href="/favicon.ico" />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Estamos en los 3 departamentos La Paz, Cochabamba y Santa Cruz."
        />
        <meta
          property="og:description"
          content="Digital Language Services es un Centro de Idiomas con 22 años de experiencia en la enseñanza de inglés, incluyendo cursos de preparación para exámenes TOEFL iBT e IELTS."
        />
        <meta
          property="og:image"
          content="https://dls.com.bo/static/media/logo_DLS.6424b652d76d8584dbc3.png"
        />
        <meta property="og:url" content="https://dls.com.bo/#/contactos" />

        <link rel="canonical" href="https://dls.com.bo" />
      </Helmet>
      <Box
        sx={{
          width: "auto",
          display: "block",
        }}
      >
        <Box>
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={banne3}
                  alt="Digital Language Services"
                  className="animate__animated animate__fadeInLeft img-dim-banner"
                />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    padding: "20px 0",
                    clipPath: {
                      xs: "none",
                      sm: "none",
                      md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: {
                        xs: "25px",
                        sm: "35px",
                        md: "30px",
                      },
                      color: "#009999",
                      fontWeight: "bold",
                    }}
                  >
                    CONTÁCTANOS
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            width: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            padding: "2px",
          }}
        >
          <Box
            sx={{
              maxWidth: {
                xs: "98vw",
                sm: "90vw",
                md: "65vw",
              },
              display: "block",
              padding: "15px 0",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "auto",
                display: "block",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  display: "block",
                  width: "auto",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "25px",
                  }}
                >
                  <Typography variant="h2" sx={{ fontSize: "26px" }}>
                    Administrador a Nivel Nacional
                  </Typography>
                </Box>
                <br />
                <hr />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "5px 0 25px 0",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    DANIEL ROMANO - ADMINISTRADOR / TOEFL PROCTOR
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "block",
                      justifyContent: "center",
                      width: "40vw",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ fontWeight: "bold" }}>
                        CORREO: &nbsp;
                      </Typography>
                      <Typography>dromano@dls.com.bo</Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography sx={{ fontWeight: "bold" }}>
                        NUMERO:&nbsp;{" "}
                      </Typography>
                      <Typography>
                        <a
                          href="https://wa.me/59175384234"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          +59173587107
                        </a>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <hr />
              </Box>
              <Box sx={{ width: "100%", padding: "15px 0" }}>
                <Box p={3} sx={{ fontWeight: "bold" }}>
                  NUESTRAS SUCURSALES
                </Box>
                <Box
                  sx={{
                    background: "#009999",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab
                      label="LA PAZ"
                      {...a11yProps(0)}
                      sx={{
                        color: "#d1d1d1",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    />
                    <Tab
                      label="SANTA CRUZ"
                      {...a11yProps(1)}
                      sx={{
                        color: "#d1d1d1",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    />
                    <Tab
                      label="COCHABAMBA"
                      {...a11yProps(2)}
                      sx={{
                        color: "#d1d1d1",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    />
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "45px 0 15px 0",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold" }}>
                      SUCURSAL LA PAZ
                    </Typography>
                  </Box>
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                      <hr />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          DIRECCION:&nbsp;{" "}
                        </Typography>
                        <Typography>
                          Calle Pinilla & Av. Arce No. 2588, Edificio Arcadia,
                          Piso 13 Of. 13G
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          NUMERO:&nbsp;{" "}
                        </Typography>
                        <Typography>
                          <a
                            href="https://wa.me/59173587107"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            +59173587107
                          </a>
                        </Typography>
                      </Box>
                      <hr />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                      <div style={{ width: "100%", height: "300px" }}>
                        <iframe
                          title="Google Maps"
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d416.2655175729567!2d-68.12362138094953!3d-16.51052865158064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x915f217333f538e9%3A0xc3c8a376676d3a01!2sEdificio%20Arcadia!5e0!3m2!1ses!2sbo!4v1734140323764!5m2!1ses!2sbo"
                          width="100%"
                          height="100%"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                        ></iframe>
                      </div>
                    </Grid2>
                  </Grid2>
                  <Box
                    sx={{ display: "block", width: "auto", padding: "25px 0" }}
                  >
                    <Typography component="span" sx={{ fontWeight: "bold" }}>
                      Nuestras Instalaciones - La Paz
                    </Typography>

                    <GaleriaLaPaz />
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "45px 0 15px 0",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold" }}>
                      SUCURSAL SANTA CRUZ
                    </Typography>
                  </Box>
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                      <hr />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          DIRECCION:&nbsp;{" "}
                        </Typography>
                        <Typography>
                          Avenida Alemana No. 3385 Cuarto Anillo
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          ESTEFANIA VACA :&nbsp;{" "}
                        </Typography>
                        <Typography>TOEFL Proctor</Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          NUMERO:&nbsp;{" "}
                        </Typography>
                        <Typography>
                          <a
                            href="https://wa.me/59175384234"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            +59175384234
                          </a>
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          CORREO:&nbsp;{" "}
                        </Typography>
                        <Typography>gchoque@dls.com.bo</Typography>
                      </Box>
                      <hr />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                      <div style={{ width: "100%", height: "300px" }}>
                        <iframe
                          title="Google Maps"
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2182.4287798655096!2d-63.16521648510978!3d-17.75269818072466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x93f1e75fe4fbbff5%3A0x8d542f76a9685a87!2sDLS%20Santa%20Cruz!5e0!3m2!1ses!2sbo!4v1734323559512!5m2!1ses!2sbo"
                          width="100%"
                          height="100%"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                        ></iframe>
                      </div>
                    </Grid2>
                  </Grid2>
                  <Box
                    sx={{ display: "block", width: "auto", padding: "25px 0" }}
                  >
                    <Typography component="span" sx={{ fontWeight: "bold" }}>
                      Nuestras Instalaciones - Santa Cruz
                    </Typography>

                    <GaleriaSantaCruz />
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "45px 0 15px 0",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold" }}>
                      SUCURSAL COCHABAMBA
                    </Typography>
                  </Box>
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                      <hr />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          DIRECCION:&nbsp;{" "}
                        </Typography>
                        <Typography>
                          Av. Julio Rodríguez y Pantaleón Dalence, Zona Queru
                          Queru
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          RUTH MAMANI :&nbsp;{" "}
                        </Typography>
                        <Typography>TOEFL Proctor</Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          NUMERO:&nbsp;{" "}
                        </Typography>
                        <Typography>
                          <a
                            href="https://wa.me/59179340220"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            +59179340220
                          </a>
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          CORREO:&nbsp;{" "}
                        </Typography>
                        <Typography>rmamani@dls.com.bo</Typography>
                      </Box>
                      <hr />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
                      <div style={{ width: "100%", height: "300px" }}>
                        <iframe
                          title="Google Maps"
                          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d237.99195723376752!2d-66.154401028334!3d-17.369924114530978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses!2sbo!4v1734324444655!5m2!1ses!2sbo"
                          width="100%"
                          height="100%"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                        ></iframe>
                      </div>
                    </Grid2>
                  </Grid2>
                  <Box
                    sx={{ display: "block", width: "auto", padding: "25px 0" }}
                  >
                    <Typography component="span" sx={{ fontWeight: "bold" }}>
                      Nuestras Instalaciones - Cochabamba
                    </Typography>

                    <GaleriaCochabamba />
                  </Box>
                </CustomTabPanel>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Contactos;
